var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemanticui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_12998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "#34BDB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8342 8.41633C14.5671 7.68114 13.4422 7.10299 11.9707 7.12849C11.1289 7.14311 10.4061 7.60071 10.2541 8.43817C10.1126 9.21733 10.8052 9.64952 11.5258 9.91483C12.7208 10.3549 13.7612 10.8195 14.9354 11.3088C17.07 12.1984 18.1645 13.639 18.0352 15.4875C17.8705 17.8394 16.4551 19.5263 14.2056 20.0824C11.2661 20.8091 8.41172 19.7021 6 18.1568C6.60872 17.2295 7.31494 16.5965 7.92 15.6748C9.31331 16.2679 10.4079 17.0693 11.8656 17.1942C12.8933 17.2824 14.0579 17.2333 14.2888 16.0261C14.4969 14.9375 13.5495 14.3539 12.6254 14.0279C11.5252 13.6399 10.4272 13.1652 9.34828 12.7246C7.35394 11.91 6.54244 10.3167 6.67903 8.43977C6.67903 7.33924 7.59216 5.11483 9.831 4.42296C13.2709 3.35983 15.1661 4.44846 17.6605 6.05149C16.998 6.92767 16.4887 7.55064 15.8342 8.41633",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_12998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemanticui);
export default __webpack_public_path__ + "static/media/semanticui.f2398f55223b2676a5a292490b696288.svg";
export { ForwardRef as ReactComponent };